import { GetServerSidePropsContext } from 'next';

import {
  LandingPageServerSideRequest,
  resolveLandingPageLocale,
} from '@silvertours/back-runtime-landingpages';
import { LandingPageLegacy } from '@silvertours/front-pages';

export const getServerSideProps = (nextContext: GetServerSidePropsContext) => {
  const locale = resolveLandingPageLocale(nextContext.query.landingPage);
  const handler = new LandingPageServerSideRequest(locale);

  return handler.getServerSideProps(nextContext);
};

export default LandingPageLegacy.LandingPage;
